 const sendEmail = async(data:any) => {
fetch(`${process.env.REACT_APP_BACKEND_URL}/send-mail`, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
              })
                .then(response => response.json())
                .then(data => {
                  return data
                }).catch((err)=>{
                  throw err
                })
    
}
export default sendEmail;
